"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var use_rx_1 = require("./use-rx");
var mutable_observer_1 = require("./mutable-observer");
/**
 * Returns `true` if a given observable has a next() method.
 * @param subject$
 */
function hasNext(subject$) {
    return typeof subject$.next !== 'undefined';
}
exports.hasNext = hasNext;
/**
 * Gets initial value if the root observable is a behavior subject (as this will emit synchronously)
 * @param observable$
 */
// since we don't know what initial observable value is
// we use a unique object pointer to indicate "no initial value" with certainty
exports.UNSET_VALUE = {};
function initialObservableValue(observable$) {
    var initialValue = exports.UNSET_VALUE;
    observable$
        .subscribe(function (val) {
        initialValue = val;
    })
        .unsubscribe();
    return initialValue;
}
exports.initialObservableValue = initialObservableValue;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function createRxConfig(subject$) {
    var initVal = initialObservableValue(subject$);
    var hadInitVal = initVal !== exports.UNSET_VALUE;
    var isSubject = hasNext(subject$);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var nextValue = isSubject ? subject$.next.bind(subject$) : undefined;
    var observer = new mutable_observer_1.MutableObserver();
    return {
        isSubject: isSubject,
        initVal: initVal,
        hadInitVal: hadInitVal,
        isNext: !hadInitVal,
        nextValue: nextValue,
        observer: observer
    };
}
/**
 * `useRxState`
 *
 * Returns current value and a callback to change it by mutating a given subject.
 * Returns only current value in case of Observable.
 *
 * Example:
 * const [name, setName] = useRxState(name$)
 * where name$ could be new BehaviorSubject('None');
 *
 * setName('Alice') under the hood will call name$.next('Alice')
 *
 * @param subject$
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function useRxState(subject$) {
    var initObj = react_1.useMemo(function () { return createRxConfig(subject$); }, [subject$]);
    var _a = react_1.useState(function () { return (initObj.hadInitVal ? initObj.initVal : undefined); }), value = _a[0], setValue = _a[1];
    initObj.observer.setNext(function (nextValue) {
        if (initObj.isNext) {
            setValue(nextValue);
        }
        else {
            initObj.isNext = true;
            delete initObj.initVal; // eliminate reference after using
        }
    });
    use_rx_1.useRx(subject$, initObj.observer);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return [value, initObj.nextValue];
}
exports.useRxState = useRxState;
/**
 * `useRxStateResult`
 *
 * For a given observable returns a current value.
 *
 * Example:
 * const name = useRxStateResult(name$)
 *
 * @param observable$
 */
function useRxStateResult(observable$) {
    var value = useRxState(observable$)[0];
    return value;
}
exports.useRxStateResult = useRxStateResult;
/**
 * `useRxStateAction`
 *
 * For a given subject returns a set function.
 *
 * Example:
 * const setName = useRxStateResult(name$);
 */
function useRxStateAction(subject$) {
    var next = react_1.useMemo(function () { return subject$.next.bind(subject$); }, [subject$]);
    return next;
}
exports.useRxStateAction = useRxStateAction;
//# sourceMappingURL=use-rx-state.js.map